import { render, staticRenderFns } from "./XFilterGroup.vue?vue&type=template&id=183faa2f"
import script from "./XFilterGroup.vue?vue&type=script&lang=js"
export * from "./XFilterGroup.vue?vue&type=script&lang=js"
import style0 from "./XFilterGroup.vue?vue&type=style&index=0&id=183faa2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports